(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $b40b300a30bc2fb0$exports = {};
$b40b300a30bc2fb0$exports = Flickity;


(function($) {
    const { findHtmlEl: findHtmlEl, findHtmlEls: findHtmlEls } = pm.utils.dom;
    /**
   * The navigation bar.
   */ const navbar = findHtmlEl("#header .wpbf-navigation");
    /**
   * The visual border to separate the sticky nav and sticky album.
   */ const albumNavSep = document.createElement("div");
    albumNavSep.classList.add("sticky-nav-separator");
    navbar?.appendChild(albumNavSep);
    /**
   * The photo gallery list.
   */ const galleryList = findHtmlEl(".photo-grid");
    /**
   * Album heading element.
   */ const albumHeading = findHtmlEl(".album-heading");
    /**
   * Album heading element.
   */ const albumHeadingTitle = findHtmlEl(".album-heading-title");
    /**
   * Album nav element.
   */ const albumNav = findHtmlEl(".album-nav");
    /**
   * Album list element.
   */ const albumList = findHtmlEl(".album-nav .album-list");
    /**
   * Total album items.
   */ let totalAlbumItems = 1;
    /**
   * The distance to the top in order to turn the album nav sticky.
   */ let stickyDistance;
    /**
   * The album's Flickity instance.
   */ let albumScroller = null;
    /**
   * Init the module.
   */ function init() {
        if (!albumNav || !albumList) return;
        totalAlbumItems = albumList.querySelectorAll(".album-item").length;
        if (totalAlbumItems > 1) albumNav.classList.remove("is-hidden");
        window.addEventListener("resize", onWindowResize);
        window.addEventListener("scroll", onWindowScroll);
        window.addEventListener("hashchange", onHashChange);
        const albumHeadingTopOffset = albumHeading ? $(albumHeading).offset()?.top ?? 0 : 0;
        const albumHeadingOuterHeight = albumHeading ? $(albumHeading).outerHeight() ?? 0 : 0;
        stickyDistance = albumHeadingTopOffset + albumHeadingOuterHeight;
        decideStickyAlbumNav();
        initAlbumScroll();
        checkHash();
    }
    /**
   * Function to run on window resize.
   */ function onWindowResize() {
        const albumHeadingTopOffset = albumHeading ? $(albumHeading).offset()?.top ?? 0 : 0;
        const albumHeadingOuterHeight = albumHeading ? $(albumHeading).outerHeight() ?? 0 : 0;
        stickyDistance = albumHeadingTopOffset + albumHeadingOuterHeight;
        decideStickyAlbumNav();
    }
    /**
   * Check current URL hash.
   */ function checkHash() {
        const hashValue = window.location.hash.substring(1);
        if (!hashValue || hashValue === "all-photos") return;
        const target = findHtmlEl(".album-item[data-album-slug='" + hashValue + "']");
        if (target) {
            switchTab(target);
            albumScroller?.selectCell('[data-album-slug="' + hashValue + '"]', false, false);
        }
    }
    /**
   * Function to run on URL hash change.
   */ function onHashChange(e) {
        const hashValue = window.location.hash.substring(1);
        let target = null;
        if (hashValue) target = findHtmlEl(".album-item[data-album-slug='" + hashValue + "']");
        else target = findHtmlEl(".album-item[data-album-slug='all-photos']");
        if (target) switchTab(target);
    }
    /**
   * Switch tab when an album button is clicked.
   *
   * @param {HTMLElement} target The targetted active tab.
   */ function switchTab(target) {
        const albumItems = findHtmlEls(".album-item");
        albumItems.forEach(function(albumItem) {
            if (albumItem !== target) albumItem.classList.remove("is-active");
        });
        const albumSlug = target.dataset.albumSlug;
        if (albumSlug === "all-photos") {
            if (galleryList) galleryList.dataset.albumSlug = "";
        } else if (galleryList) galleryList.dataset.albumSlug = albumSlug;
        if (albumHeadingTitle) albumHeadingTitle.innerHTML = findHtmlEl(target, ".album-name")?.innerHTML ?? "";
        target.classList.add("is-active");
        galleryList?.classList.add("is-hidden");
        const albumHeadingTopOffset = albumHeading ? $(albumHeading).offset()?.top ?? 0 : 0;
        const albumHeadingClientHeight = albumHeading ? albumHeading.clientHeight : 0;
        const albumListClientHeight = albumList ? albumList.clientHeight : 0;
        const scrollTopTarget = albumHeadingTopOffset - albumHeadingClientHeight - albumListClientHeight;
        if (document.body.classList.contains("has-sticky-album-nav")) $("html, body").stop().animate({
            scrollTop: scrollTopTarget
        }, 150);
        if (window.pm.module.loadMore) window.pm.module.loadMore.hideEmptyNotice();
        findHtmlEl(target, ".album-button")?.focus();
        if (window.pm.module.loadMore) window.pm.module.loadMore.resetPhotosLoad();
    }
    /**
   * Function to run on window scroll
   */ function onWindowScroll() {
        if (totalAlbumItems < 2) return;
        decideStickyAlbumNav();
    }
    /**
   * Decide whether or not to make the album nav sticky.
   */ function decideStickyAlbumNav() {
        if (window.scrollY > stickyDistance + 300) {
            const shouldChange = albumNav ? !albumNav.classList.contains("is-sticky") : false;
            // Make album nav sticky.
            if (albumNav && shouldChange) {
                albumNav.classList.add("is-sticky");
                setTimeout(function() {
                    albumNav.style.opacity = "1";
                }, 30);
                navbar?.appendChild(albumNav);
                navbar?.classList.add("has-album-nav");
                if (albumHeading) albumHeading.style.marginBottom = albumNav.clientHeight + "px";
                document.body.classList.add("has-sticky-album-nav");
            }
        } else if (window.scrollY < stickyDistance + 200) {
            const shouldChange = albumNav?.classList.contains("is-sticky") ?? false;
            const reference = albumHeading?.parentElement ? findHtmlEl(albumHeading.parentElement, ".no-items-found") : null;
            // Make album nav un-sticky.
            if (albumNav && shouldChange) {
                albumNav.classList.remove("is-sticky");
                albumNav.removeAttribute("style");
                if (albumHeading) {
                    albumHeading.parentElement?.insertBefore(albumNav, reference);
                    albumHeading.style.marginBottom = "";
                }
                navbar?.classList.remove("has-album-nav");
                document.body.classList.add("has-sticky-album-nav");
            }
        }
    }
    /**
   * Horizontal drag scrolling.
   */ function initAlbumScroll() {
        if (!albumList) return;
        albumList.classList.remove("is-hidden");
        albumList.offsetHeight;
        albumScroller = new (0, (/*@__PURE__*/$parcel$interopDefault($b40b300a30bc2fb0$exports)))(albumList, {
            cellAlign: "left",
            freeScroll: true,
            contain: true,
            percentPosition: false,
            prevNextButtons: false,
            pageDots: false,
            on: {
                ready: function() {
                //
                }
            }
        });
    }
    init();
})(jQuery);

})();
//# sourceMappingURL=album-view.js.map
